import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

// Fires exactly one `page_view` dataLayer event per route change (SPA
// navigations don't trigger a browser page load, so GTM/GA4's automatic
// pageview never fires on their own — this is the single source of truth).
// Mounted once, inside <BrowserRouter>, above <AppRouter>.
export default function AnalyticsProvider({ children }) {
  const location = useLocation();
  const lastTracked = useRef(null);

  useEffect(() => {
    const key = location.pathname + location.search;
    if (lastTracked.current === key) return; // dedupe StrictMode double-invoke
    lastTracked.current = key;
    trackPageView();
  }, [location.pathname, location.search]);

  return children;
}
